import React from "react";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/CustomButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import PrintIcon from "@material-ui/icons/PictureAsPdf";
import TableRowsIcon from "@material-ui/icons/TableChart";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Typography from "@material-ui/core/Typography";

const COLORS = {
  main: "#4D90FD",
  pastel1: "#dbe8fe",
};

const fmtMoney = (v) =>
  typeof v === "number"
    ? v.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : Number(v || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

export default function AgentList({
  title = "",
  info = {},
  forma = {},
  report_tz = "",
  timezones = {},
  onGeneratePdf,
  onGenerateCsv,
  onBack,
}) {
  return (
    <div className="container-fluid" style={{ padding: 20 }}>
      <form id="report_form">
        {forma &&
          Object.entries(forma).map(([field_name, field_value]) => (
            <input
              key={field_name}
              type="hidden"
              name={field_name}
              value={field_value}
              readOnly
            />
          ))}
      </form>
      <div className="cl-mcont">
        <GridContainer style={{ paddingTop: 20 }}>
          <GridItem xs={12}>
            <div className="block-flat" style={{ padding: 20, background: "#fff", borderRadius: 8 }}>
              {/* Header */}
              <GridContainer style={{ marginBottom: 16 }}>
                <GridItem xs={12} sm={6}>
                  <Typography variant="h6">
                    {report_tz
                      ? `${timezones?.[report_tz]} - ${report_tz.toUpperCase()}`
                      : ""}
                  </Typography>
                  <Typography variant="h5">{title}</Typography>
                </GridItem>
                <GridItem xs={12} sm={6} style={{ textAlign: "right" }}>
                  <Button
                    variant="primary"
                    startIcon={<PrintIcon />}
                    onClick={onGeneratePdf}
                    style={{ marginLeft: 20 }}
                  >
                    PDF
                  </Button>
                  <Button
                    variant="primary"
                    startIcon={<TableRowsIcon />}
                    onClick={onGenerateCsv}
                    style={{ marginLeft: 20 }}
                  >
                    CSV
                  </Button>
                  <Button
                    variant="default"
                    startIcon={<ArrowBackIcon />}
                    onClick={onBack}
                    style={{ marginLeft: 20 }}
                  >
                    Back To Reports
                  </Button>
                </GridItem>
              </GridContainer>
              {/* Date + Company */}
              <GridContainer style={{ marginBottom: 20 }}>
                <GridItem xs={12} sm={2}>
                  Date: {new Date().toLocaleString()}
                </GridItem>
                <GridItem xs={12} sm={10} style={{ textAlign: "right", fontSize: 20 }}>
                  HDI Seguros, S.A. de C.V.
                </GridItem>
              </GridContainer>
              {/* Main Table */}
              <TableContainer component={Paper}>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        colSpan={9}
                        style={{
                          background: COLORS.main,
                          color: "#fff",
                          fontWeight: 700,
                        }}
                      >
                        {info.agency?.code} {info.agency?.name}
                      </TableCell>
                    </TableRow>
                    {info.details &&
                      Object.entries(info.details).map(([date, rows]) => (
                        <React.Fragment key={date}>
                          <TableRow>
                            <TableCell
                              colSpan={9}
                              style={{
                                background: COLORS.pastel1,
                                color: "#000",
                                fontWeight: 700,
                              }}
                            >
                              Issue Date: {new Date(date).toLocaleDateString()}
                            </TableCell>
                          </TableRow>
                          {rows.map((agencies, idxA) =>
                            Object.entries(agencies).map(([agent, method], idxB) => {
                              let subtotal = {
                                net: 0,
                                policy: 0,
                                iva: 0,
                                total: 0,
                                agency: 0,
                                collected: 0,
                              };
                              let total = {
                                "Credit Card": {
                                  net: 0,
                                  policy: 0,
                                  iva: 0,
                                  total: 0,
                                  agency: 0,
                                  collected: 0,
                                },
                                "Agent Will Charge": {
                                  net: 0,
                                  policy: 0,
                                  iva: 0,
                                  total: 0,
                                  agency: 0,
                                  collected: 0,
                                },
                              };
                              return (
                                <React.Fragment key={agent + idxB}>
                                  <TableRow>
                                    <TableCell style={{ background: COLORS.pastel1, color: "#000" }}>Policy Number</TableCell>
                                    <TableCell style={{ background: COLORS.pastel1, color: "#000" }}>Customer Name</TableCell>
                                    <TableCell style={{ background: COLORS.pastel1, color: "#000" }}>Net Premium</TableCell>
                                    <TableCell style={{ background: COLORS.pastel1, color: "#000" }}>Policy Fee</TableCell>
                                    <TableCell style={{ background: COLORS.pastel1, color: "#000" }}>IVA</TableCell>
                                    <TableCell style={{ background: COLORS.pastel1, color: "#000" }}>Total Premium</TableCell>
                                    <TableCell style={{ background: COLORS.pastel1, color: "#000" }}>Agency Fee</TableCell>
                                    <TableCell style={{ background: COLORS.pastel1, color: "#000" }}>Total Collected</TableCell>
                                    <TableCell style={{ background: COLORS.pastel1, color: "#000" }}>Payment Type</TableCell>
                                  </TableRow>
                                  {method.map((row, idxRow) => {
                                    subtotal.net += row.revised_net_premium;
                                    subtotal.policy += row.policy_fee;
                                    subtotal.iva += row.iva;
                                    subtotal.total += row.total;
                                    subtotal.agency += row.agency_fee;
                                    subtotal.collected += row.total + row.agency_fee;
                                    if (total[row.payment_type_name]) {
                                      total[row.payment_type_name].net += row.revised_net_premium;
                                      total[row.payment_type_name].policy += row.policy_fee;
                                      total[row.payment_type_name].iva += row.iva;
                                      total[row.payment_type_name].total += row.total;
                                      total[row.payment_type_name].agency += row.agency_fee;
                                      total[row.payment_type_name].collected += row.total + row.agency_fee;
                                    }
                                    return (
                                      <TableRow key={idxRow} className="odd gradeX">
                                        <TableCell>{row.policy_nbr}</TableCell>
                                        <TableCell style={{ textTransform: "uppercase" }}>{row.client_name}</TableCell>
                                        <TableCell>${fmtMoney(row.revised_net_premium)}</TableCell>
                                        <TableCell>${fmtMoney(row.policy_fee)}</TableCell>
                                        <TableCell>${fmtMoney(row.iva)}</TableCell>
                                        <TableCell>${fmtMoney(row.total)}</TableCell>
                                        <TableCell>${fmtMoney(row.agency_fee)}</TableCell>
                                        <TableCell>${fmtMoney(row.total + row.agency_fee)}</TableCell>
                                        <TableCell>{row.payment_type_name}</TableCell>
                                      </TableRow>
                                    );
                                  })}
                                  <TableRow className="odd gradeX">
                                    <TableCell>Agent #{agent}</TableCell>
                                    <TableCell>
                                      <strong>
                                        Total {method[0]?.payment_type_name} Sales:
                                      </strong>
                                    </TableCell>
                                    <TableCell>${fmtMoney(subtotal.net)}</TableCell>
                                    <TableCell>${fmtMoney(subtotal.policy)}</TableCell>
                                    <TableCell>${fmtMoney(subtotal.iva)}</TableCell>
                                    <TableCell>${fmtMoney(subtotal.total)}</TableCell>
                                    <TableCell>${fmtMoney(subtotal.agency)}</TableCell>
                                    <TableCell>${fmtMoney(subtotal.collected)}</TableCell>
                                    <TableCell>&nbsp;</TableCell>
                                  </TableRow>
                                  {/* Totales por tipo de pago */}
                                  <TableRow className="odd gradeX">
                                    <TableCell></TableCell>
                                    <TableCell>
                                      <strong>Total Daily Credit Card Sales</strong>
                                    </TableCell>
                                    <TableCell>${fmtMoney(total["Credit Card"].net)}</TableCell>
                                    <TableCell>${fmtMoney(total["Credit Card"].policy)}</TableCell>
                                    <TableCell>${fmtMoney(total["Credit Card"].iva)}</TableCell>
                                    <TableCell>${fmtMoney(total["Credit Card"].total)}</TableCell>
                                    <TableCell>${fmtMoney(total["Credit Card"].agency)}</TableCell>
                                    <TableCell>${fmtMoney(total["Credit Card"].collected)}</TableCell>
                                    <TableCell></TableCell>
                                  </TableRow>
                                  <TableRow className="odd gradeX">
                                    <TableCell></TableCell>
                                    <TableCell>
                                      <strong>Total Daily Agent Will Charge Sales</strong>
                                    </TableCell>
                                    <TableCell>${fmtMoney(total["Agent Will Charge"].net)}</TableCell>
                                    <TableCell>${fmtMoney(total["Agent Will Charge"].policy)}</TableCell>
                                    <TableCell>${fmtMoney(total["Agent Will Charge"].iva)}</TableCell>
                                    <TableCell>${fmtMoney(total["Agent Will Charge"].total)}</TableCell>
                                    <TableCell>${fmtMoney(total["Agent Will Charge"].agency)}</TableCell>
                                    <TableCell>${fmtMoney(total["Agent Will Charge"].collected)}</TableCell>
                                    <TableCell></TableCell>
                                  </TableRow>
                                </React.Fragment>
                              );
                            })
                          )}
                        </React.Fragment>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* Bottom Buttons */}
              <GridContainer style={{ marginTop: 16 }}>
                <GridItem xs={12} sm={6} />
                <GridItem xs={12} sm={6}>
                  <GridContainer>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="primary"
                        startIcon={<PrintIcon />}
                        onClick={onGeneratePdf}
                        style={{ width: "100%" }}
                      >
                        PDF
                      </Button>
                    </GridItem>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="primary"
                        startIcon={<TableRowsIcon />}
                        onClick={onGenerateCsv}
                        style={{ width: "100%" }}
                      >
                        CSV
                      </Button>
                    </GridItem>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="default"
                        style={{
                          background: "#FFF",
                          borderColor: COLORS.main,
                          color: COLORS.main,
                          border: "1px solid",
                          width: "100%",
                        }}
                        startIcon={<ArrowBackIcon />}
                        onClick={onBack}
                      >
                        Back To Reports
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </div>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}